import React from 'react';
import styled from 'styled-components';
import { palette } from 'styles/color';
import { IconRight, IconLeft } from 'assets/icon';

const Dropdown = ({
  options,
  value,
  onChange,
  align = 'left',
  placeholder = 'Select an option',
  headerStyle = {},
  listStyle = {}
}: {
  options: any[];
  value: string | null;
  onChange: (value: string) => void;
  align?: 'left' | 'right';
  placeholder?: string;
  headerStyle?: React.CSSProperties;
  listStyle?: React.CSSProperties;
}) => {
  const [isOpen, setIsOpen] = React.useState(false);

  const handleSelect = (optionValue: string) => {
    onChange(optionValue);
    setIsOpen(false);
  };

  return (
    <DropdownContainer>
      <DropdownHeader onClick={() => setIsOpen(!isOpen)} isOpen={isOpen} style={headerStyle}>
        {options.find((option) => option.value === value)?.label || placeholder}
        <IconWrapper>{isOpen ? <IconLeft /> : <IconRight />}</IconWrapper>
      </DropdownHeader>
      {isOpen && (
        <DropdownList align={align} style={listStyle}>
          {options.map((option) => (
            <DropdownItem
              key={option.value}
              onClick={() => handleSelect(option.value)}
              isActive={option.value === value}>
              {option.label}
            </DropdownItem>
          ))}
        </DropdownList>
      )}
    </DropdownContainer>
  );
};

export default Dropdown;

const DropdownContainer = styled.div`
  position: relative;
`;

const DropdownHeader = styled.div<{ isOpen: boolean }>`
  padding: 10.5px 12px;
  background: ${palette.white};
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  line-height: 100%;
  color: ${palette.gray[700]};
  width: fit-content;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;

  ${({ isOpen }) =>
    isOpen &&
    `
    border-color: ${palette.gray[500]};
  `}
`;

const IconWrapper = styled.span`
  margin-left: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 12px;
  transform: rotate(90deg);
  color: ${palette.gray[700]};
`;

const DropdownList = styled.ul<{ align: 'left' | 'right' }>`
  min-width: 140px;
  // max-width: 185px;
  width: max-content;
  margin: 0;
  padding: 8px;
  overflow: hidden;
  position: absolute;
  top: calc(100% + 3px);
  ${({ align }) => (align === 'right' ? 'right: 0;' : 'left: 0;')}
  list-style: none;
  background: ${palette.white};
  border-radius: 6px;
  z-index: 10;
  box-shadow: 0px 0px 8px 0px #00000033;
`;

const DropdownItem = styled.li<{ isActive: boolean }>`
  padding: 8px 6px;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  cursor: pointer;
  border-radius: 4px;

  ${({ isActive }) =>
    isActive &&
    `
    background: ${palette.gray[200]} !important;
  `}

  &:hover {
    background: ${palette.gray[100]};
  }
`;
